import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag, BadgeCheck } from "lucide-react";

const purchases = [
  { name: "Rina", city: "Bandung" },
  { name: "Agus", city: "Jakarta" },
  { name: "Putri", city: "Surabaya" },
  { name: "Dimas", city: "Yogyakarta" },
  { name: "Sari", city: "Semarang" },
  { name: "Bayu", city: "Medan" },
  { name: "Lina", city: "Makassar" },
  { name: "Eko", city: "Malang" },
  { name: "Fitri", city: "Palembang" },
  { name: "Rudi", city: "Denpasar" },
];

export const SocialProof = () => {
  const [index, setIndex] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => setStarted(true), 5000);
    return () => clearTimeout(startTimer);
  }, []);

  useEffect(() => {
    if (!started) return;
    const id = setInterval(() => setIndex((i) => (i + 1) % purchases.length), 5000);
    return () => clearInterval(id);
  }, [started]);

  if (!started) return null;
  const p = purchases[index];

  return (
    <div className="fixed left-3 md:left-6 top-20 md:top-24 z-40 pointer-events-none">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: -24, scale: 0.92 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -16, scale: 0.95 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-center gap-2 rounded-xl bg-white/90 backdrop-blur-xl border border-slate-200 shadow-[0_8px_28px_rgba(15,23,42,0.12)] px-3 py-2 max-w-[240px]"
          data-testid="social-proof-notification"
        >
          <span className="shrink-0 w-7 h-7 rounded-lg bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center">
            <ShoppingBag className="w-3.5 h-3.5 text-white" strokeWidth={2.2} />
          </span>
          <div className="min-w-0">
            <p className="text-xs font-bold text-slate-900 leading-snug">
              {p.name} dari {p.city} baru saja order
            </p>
            <p className="text-[10px] text-slate-500 flex items-center gap-1 mt-0.5">
              <BadgeCheck className="w-3 h-3 text-blue-500 shrink-0" />
              Gemini Pro 18 Bulan · <span className="font-bold text-blue-600">Rp79rb</span>
            </p>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
